import { createTheme } from '@mui/material/styles';

import { components } from './components';
import { darkScheme, lightScheme } from './palette';
import { typography } from './typography';

declare module '@mui/material/styles' {
  interface BreakpointOverrides {
    xxl: true;
  }
}

/**
 * CSS-variable theme: the colour scheme resolves from a `data-mui-color-scheme`
 * attribute, so switching modes never re-renders the tree. Default mode is
 * "light" (set in root.tsx/AppProviders), not the visitor's OS preference.
 */
export const theme = createTheme({
  cssVariables: { colorSchemeSelector: 'data' },
  colorSchemes: { light: lightScheme, dark: darkScheme },
  typography,
  components,
  shape: { borderRadius: 4 },
  spacing: 4,
  breakpoints: {
    values: { xs: 0, sm: 600, md: 900, lg: 1200, xl: 1536, xxl: 1920 },
  },
});
